const normalizeText = (value) => {
  if (typeof value !== "string") return "";
  return value.trim();
};

export const getDisplayNameFromInfo = (info, fallback = "—") => {
  if (!info) return fallback;

  const preferredName =
    normalizeText(info.display_name) || normalizeText(info.name);
  if (preferredName) {
    return preferredName;
  }

  const legacyName = [info.first_name, info.last_name]
    .map(normalizeText)
    .filter(Boolean)
    .join(" ")
    .trim();

  if (legacyName) {
    return legacyName;
  }

  return normalizeText(fallback) || "—";
};

export const getDisplayNameFromUser = (user, fallback = "—") => {
  if (!user) return fallback;

  const info = user.info ?? user;
  const userFallback =
    normalizeText(user.display_name) ||
    normalizeText(user.name) ||
    normalizeText(user.username) ||
    normalizeText(fallback) ||
    "—";

  return getDisplayNameFromInfo(info, userFallback);
};
